















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import SurveyQuestion from '@/components/lfs/Surveys/Questions/SurveyQuestion.vue'

const surveys = namespace('surveys')

@Component({
    name: "SurveyQuestionChildren",
  components: {
    SurveyQuestion
  }
})
export default class SurveyQuestionChildren extends Vue {
  @Prop({type: Object, default: {}}) protected question!: any
  @Prop({type: Boolean, default: false}) protected isEdit!: boolean
  @Prop({ type: String, default: ''}) protected currentQuestionId!: string;

  addAnswers(question:any) {
    this.$emit('addAnswers', question)
  }

  deleteQuestion(question:any) {
    this.$emit('deleteQuestion', question)
  }

  deleteAnswer(question:any, answer:any) {
    this.$emit('deleteAnswer', question, answer)
  }
  
  changeIncludes(answer:any) {
    this.$emit('changeIncludes', answer, this.question.text, this.question)
  }

  chooseQuestion(question:any) {
    this.$emit('chooseQuestion', question)
  }

}
